export const OVERLAY_TYPE_READ_ONLY = 'readOnly'
